import { render, staticRenderFns } from "./NewEnviosTable.vue?vue&type=template&id=6df6d4d0"
import script from "./NewEnviosTable.vue?vue&type=script&lang=js"
export * from "./NewEnviosTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports